
<!-- chanhdru -->

<div class="chat-popup-container" *ngIf="showSharePopup">
    <div class="chat-popup animate-popup">
        <div class="chat-header">
            <div>
                <div *ngIf="feedData?.feed_type === 'JOBS'" class="posted-job">
                    #New Job Opportunity Posted by
                    <span style="text-transform: capitalize"> {{ displayName }}</span>
                </div>
                <div *ngIf="talentData" class="posted-job">
                    #New Talent Posted by
                    <span style="text-transform: capitalize"> {{ talentData?.full_name }}</span>
                </div>
                <div *ngIf="feedData?.feed_type === 'LEARNHUB'" class="posted-job">
                    #New Course
                    <span style="text-transform: capitalize">
                        {{ feedData.courses[0].type }}</span>
                    <span> Posted</span>
                </div>
                <div *ngIf="feedData?.feed_type === 'CATALOGUE'" class="posted-job">
                    #New CATALOGUE Posted
                </div>
                <div class="posted-job" *ngIf="feeDirdData">
                    #New Directory Posted by
                    <span style="text-transform: capitalize">
                        {{ feeDirdData?.company_name || feeDirdData?.name }}</span>
                </div>

                <div class="posted-job" *ngIf="feedData?.user_role && feedData?.user_id">
                    <span style="text-transform: capitalize">
                        {{ displayName }}</span> Post

                </div>
            </div>

            <div>
                <button mat-icon-button class="icon-bubble close-btn" (click)="closeChatPopup()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <div class="chat-body">
            <!-- newfeeds -->
            <div class="master_feed_sec" *ngIf="shouldShowUserInfo || feedData?.user_role && feedData?.user_id">
                <div class="feed_right">
                    <div class="feed_header">
                        <!--  -->
                        <div class="media">
                            <!-- Avatar -->
                            <div class="mediall-left">
                                <!-- Admin static logo -->
                                <ng-container *ngIf="isAdmins; else userAvatar">
                                    <img src="../../../../../assets/images/logo.svg" alt="Admin Icon"
                                        style="object-fit: contain" />
                                </ng-container>

                                <!-- Other users -->
                                <ng-template #userAvatar>
                                    <ng-container *ngIf="showAvatarImage; else showInitials">
                                        <img [src]="avatarUrl" (error)="onImageError($event, 'alt_img.jpg')"
                                            alt="User Avatar" style="object-fit: contain" />
                                    </ng-container>
                                </ng-template>

                                <!-- Fallback Initials -->
                                <ng-template #showInitials>
                                    <span class="user-logo">{{ initials }}</span>
                                </ng-template>
                            </div>

                            <!-- Body -->
                            <div class="media-body">
                                <div class="flex_title_time">
                                    <div>
                                        <p class="feedNameTitle">{{ displayName }}</p>
                                        <p class="time_feed">
                                            {{ displayTime | date : "dd-MM-yyyy hh:mm a" }}
                                        </p>
                                    </div>
                                    <div class="time" style="text-align: right"></div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="
                                feedData?.feed_type === 'CATALOGUE' ||
                                feedData?.feed_type === 'JOBS' ||
                                feedData?.feed_type === 'LEARNHUB'
                            " class="catalogue-container">
                            <!-- catalogue -->
                            <div class="catalogue-content" *ngIf="feedData?.feed_type === 'CATALOGUE'">
                                <div class="catalogue-media">
                                    <div *ngFor="let media of displayedMedia; let i = index" class="media-item">
                                        <ng-container *ngIf="isImage(media)">
                                            <img [src]="media?.url" class="catalogue-image"
                                                onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/alt_img.jpg";'
                                                alt="Catalogue image" loading="eager" />
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="catalogue-data">
                                    <div *ngIf="feedData?.dental_supplier_id" class="contact-info">
                                        <div *ngIf="feedData?.dental_supplier_id" class="contact-details">
                                            <p class="catalogue-title">
                                                New {{ feedData?.catalogues[0]?.catalogue_category?.name
                                                }} catalogue
                                            </p>
                                            <p class="company-name">
                                                Posted by {{ feedData?.dental_supplier?.directories[0]
                                                ?.company_name }}
                                            </p>
                                            <p class="subcategory" *ngIf="
                                        feedData?.catalogues?.catalogue_sub_category?.name
                                        ">
                                                {{ feedData?.catalogues[0]?.catalogue_sub_category?.name
                                                }}
                                            </p>
                                            <p class="subcategory" *ngIf="feedData?.title">
                                                {{ feedData?.catalogues[0]?.title }}
                                            </p>

                                            <div class="contact-item">
                                                <span class="icon-wrapper">
                                                    <img src="../../../../../assets/images/icons/mail.svg"
                                                        alt="Email icon" />
                                                </span>
                                                <span class="contact-text">{{ feedData?.dental_supplier?.email }}</span>
                                            </div>

                                            <div class="contact-item">
                                                <span class="icon-wrapper">
                                                    <img src="../../../../../assets/images/icons/call_color.svg"
                                                        alt="Phone icon" />
                                                </span>
                                                <span class="contact-text">{{ feedData?.dental_supplier?.phone }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Jobs -->
                            <div *ngIf="feedData?.feed_type === 'JOBS'">
                                <div class="job-card">
                                    <div class="job-banner" *ngIf="feedData?.jobs[0]?.banner_image?.length">
                                        <img [src]="feedData?.jobs[0]?.banner_image[0]?.url" alt="Job banner" loading="lazy" />
                                    </div>
                            
                                    <div class="job-content">
                                        <div class="job-header" style="display: flex; flex-direction: column; gap: 10px">
                                            <div class="" style="
                                                      display: flex;
                                                      justify-content: space-between;
                                                      width: 100%;
                                                      align-items: center;
                                                    ">
                                                <div style="display: flex; flex-direction: column">
                                                    <div style="
                                                          font-size: 13px;
                                                          font-weight: 400;
                                                          font-family: 'Poppins', sans-serif;
                                                          color: #748294;
                                                        ">
                                                        Title
                                                    </div>
                                                    <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                                                        {{ feedData?.title }}
                                                    </h5>
                                                </div>
                                                <div class="posted-date">
                                                    <p>
                                                        Posted on : {{ feedData?.jobs[0]?.created_at | date
                                                        : "yyyy-MM-dd" }}
                                                    </p>
                                                </div>
                                            </div>
                            
                                            <div class="" style="
                                                      display: flex;
                                                      justify-content: space-between;
                                                      width: 100%;
                                                    ">
                                                <div style="display: flex; flex-direction: column">
                                                    <div style="
                                                          font-size: 13px;
                                                          font-weight: 400;
                                                          font-family: 'Poppins', sans-serif;
                                                          color: #748294;
                                                        ">
                                                        Roles
                                                    </div>
                                                    <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                                                        {{ feedData?.jobs[0]?.j_role }}
                                                    </h5>
                                                </div>
                                                <p class="location" *ngIf="feedData?.jobs[0]?.location">
                                                    <img src="../../../../../assets/images/icons/loc-icon.png" alt="search icon"
                                                        style="width: 18px" />
                                                    {{ feedData?.jobs[0]?.location }}
                                                </p>
                                            </div>
                                        </div>
                            
                                        <div class="job-description">
                                            <p class="description-heading">Job Description</p>
                                            <p class="description-text">
                                                {{ feedData?.description }}
                                            </p>
                                        </div>
                            
                                        <div style="
                                                    display: flex;
                                                    justify-content: space-between;
                                                    align-items: center;
                                                    margin-top: 10px;
                                                  ">
                                            <div class="employment-types">
                                                <span class="badge" *ngFor="
                                                                        let type of feedData?.jobs[0]?.TypeofEmployment
                                                                    ">
                                                    {{ type }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- learninghub -->
                            <div *ngIf="feedData?.feed_type === 'LEARNHUB'">
                                <div class="job-card">
                                    <div class="media-item" *ngIf="displayedMedia?.length > 0">
                                        <!-- If it's an image -->
                                        <img *ngIf="displayedMedia[0]?.type === 'image'" [src]="displayedMedia[0]?.url"
                                            class="catalogue-image"
                                            onerror="this.onerror=null;this.src='../../../../../assets/images/empty-imgs/alt_img.jpg';"
                                            alt="LearningHub image" />

                                        <!-- If it's a video -->
                                        <video *ngIf="displayedMedia[0]?.type === 'video'"
                                            [src]="displayedMedia[0]?.url" class="feed_video" controls>
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>

                                    <div class="job-content">
                                        <div class="job-header"
                                            style="display: flex; flex-direction: column; gap: 10px">
                                            <div class="" style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                          align-items: center;
                        ">
                                                <div style="display: flex; flex-direction: column">
                                                    <div style="
                              font-size: 13px;
                              font-weight: 400;
                              font-family: 'Poppins', sans-serif;
                              color: #748294;
                            ">
                                                        Presented By
                                                    </div>
                                                    <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                                                        {{ feedData.courses[0].presented_by_name }}
                                                    </h5>
                                                </div>
                                                <div class="posted-date">
                                                    <p>
                                                        Posted on : {{ feedData.courses[0].created_at | date
                                                        : "yyyy-MM-dd" }}
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="" style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                                                <div style="display: flex; flex-direction: column">
                                                    <div style="
                              font-size: 13px;
                              font-weight: 400;
                              font-family: 'Poppins', sans-serif;
                              color: #748294;
                            ">
                                                        CPD HOURS
                                                    </div>
                                                    <h5 class="company-name" style="font-family: 'Poppins', sans-serif">
                                                        {{ feedData.courses[0].cpd_points }}
                                                    </h5>
                                                </div>
                                                <p class="location" *ngIf="feedData.courses[0]?.address">
                                                    <img src="../../../../../assets/images/icons/loc-icon.png"
                                                        alt="search icon" style="width: 18px" />
                                                    {{ feedData.courses[0].address }}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="job-description">
                                            <p class="description-heading">Course Description</p>
                                            <p class="description-text">
                                                {{ feedData?.description }}
                                            </p>
                                        </div>

                                        <div style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-top: 10px;
                      ">
                                            <div class="employment-types">
                                                <span class="badge">
                                                    {{ feedData.courses[0].type }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end learninghub -->
                        </div>
                        <!-- news feed -->
                        <div *ngIf="
                                feedData?.feed_type !== 'CATALOGUE' &&
                                feedData?.feed_type !== 'JOBS' &&
                                feedData?.feed_type !== 'LEARNHUB'
                            ">
                            <div class="total_feed_content">{{ feedData?.description }}</div>
                            <div class="feed_body">
                                <div class="feed_img" *ngFor="let media of displayedMedia; let i = index"
                                    (click)="viewallDocuments(displayedMedia, i)">
                                    <ng-container *ngIf="isImage(media)">
                                        <img [src]="media?.url" class="feed_image" [ngStyle]="{
                                        filter:
                                        remainingCount > 0 && i === 3
                                            ? 'brightness(50%)'
                                            : 'brightness(100%)'
                                    }" onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/alt_img.jpg";'
                                            alt="" />
                                        <div *ngIf="remainingCount > 0 && i === 3" style="width: 100%; height: 100%">
                                            <div class="image-overlay">+{{ remainingCount }}</div>
                                        </div>
                                    </ng-container>
                                    <!-- Display Video -->

                                    <ng-container *ngIf="isVideo(media)">
                                        <video controls class="feed_video" [ngStyle]="{
                                        filter:
                                        remainingCount > 0 && i === 3
                                            ? 'brightness(50%)'
                                            : 'brightness(100%)'
                                    }">
                                            <source [src]="media?.url" type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                        <div *ngIf="remainingCount > 0 && i === 3">
                                            <div class="image-overlay">+{{ remainingCount }}</div>
                                        </div>
                                    </ng-container>
                                </div>

                            </div>
                            <div class="feed_document">
                                <div *ngFor="let doc of getPostDocuments(feedData); let i = index"
                                    (click)="viewallDocuments(getPostDocuments(feedData), i)">
                                    <!-- <a [href]="doc?.url"  target="_blank" rel="noopener noreferrer">{{ doc.name }}</a> -->
                                    <span style="cursor: pointer">
                                        <img src="../../../../../assets/images/file_icons/pdf.svg"
                                            *ngIf="doc?.name?.includes('.pdf')" />
                                        <img src="../../../../../assets/images/file_icons/doc.svg"
                                            *ngIf="doc?.name?.includes('.doc')" />
                                        <img src="../../../../../assets/images/file_icons/PPT.svg"
                                            *ngIf="doc?.name?.includes('.ppt')" />
                                        <img src="../../../../../assets/images/file_icons/xls.svg"
                                            *ngIf="doc?.name?.includes('.xls')" />
                                        <img src="../../../../../assets/images/file_icons/TXT.svg"
                                            *ngIf="doc?.name?.includes('.txt')" />
                                        <img src="../../../../../assets/images/file_icons/CSV.svg"
                                            *ngIf="doc?.name?.includes('.csv')" />
                                    </span>
                                </div>
                            </div>
                            <div style="padding: 15px" *ngIf="feedData?.web_url">
                                <ng-container>
                                    <div class="">
                                        Website Url :&thinsp;
                                        <a [href]="feedData?.web_url" target="_blank">
                                            {{ feedData?.web_url }}</a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- newfeeds -->

            <!-- Directory Box -->
            <div class="catalogues_box1" *ngIf="feeDirdData">
                <div class="catalogues_img1">
                    <img *ngIf="feeDirdData?.logo" [src]="feeDirdData?.logo?.url" alt="directory img"
                        onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/alt_img.jpg";' />
                    <img *ngIf="feeDirdData?.profile_image" [src]="feeDirdData?.profile_image?.url" alt="directory img"
                        onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/alt_img.jpg";' />
                </div>
                <div class="flex_center1">
                    <h4 *ngIf="feeDirdData?.company_name" class="equipment_name1" [title]="feeDirdData?.name">
                        {{ feeDirdData?.company_name }}
                    </h4>
                    <h4 *ngIf="!feeDirdData?.company_name && feeDirdData?.name" class="equipment_name1"
                        [title]="feeDirdData?.name">
                        {{ feeDirdData?.name }}
                    </h4>
                </div>
            </div>
            <!-- Directory Box -->

            <!-- talents -->
            <div class="job-card" *ngIf="talentData" style="padding: 20px;">
                <div class="job-header">
                    <ng-container *ngIf="!talentData?.post_anonymously; else showPlaceholder">
                        <div class="job-header-logo" style="
                background-color: #d9d9d9 !important;
                border-radius: 50% !important;
              ">
                            <img *ngIf="talentData.profile_image[0]?.url" [src]="talentData.profile_image[0]?.url"
                                class="company-logo" />
                        </div>
                    </ng-container>

                    <ng-template #showPlaceholder>
                        <ng-container *ngIf="talentData?.post_anonymously">
                            <img class="talent-avatars" *ngIf="
                                talentData?.dental_professional?.gender === 'male';
                                else femalePlaceholder
                                " src="../../../../../assets/images/social/male_avatar.png" alt="" />
                            <ng-template #femalePlaceholder>
                                <img class="talent-avatars" *ngIf="
                                    talentData?.dental_professional?.gender === 'female';
                                    else defaultPlaceholder
                                " src="../../../../../assets/images/social/female_avatar.png" alt="" />
                            </ng-template>
                        </ng-container>
                    </ng-template>

                    <div class="job-info" *ngIf="
                            talentData?.full_name ||
                            talentData?.job_designation ||
                            talentData?.profession_type
                            ">
                        <h4 class="company-name" *ngIf="!talentData?.post_anonymously"
                            style="font-family: 'Poppins', sans-serif">
                            {{ talentData?.full_name }}
                        </h4>
                        <h3 class="company-name" *ngIf="talentData?.job_designation">
                            {{ talentData?.job_designation }}
                        </h3>
                        <h3 class="company-name" *ngIf="talentData?.profession_type">
                            {{ talentData?.profession_type }}
                        </h3>
                    </div>
                    <div class="job-meta">
                        <div class="posted-date" *ngIf="talentData?.Year_of_experiance">
                            <p>Experience : {{ talentData?.Year_of_experiance }} Years</p>
                        </div>
                        <div>
                            <p class="location" *ngIf="talentData.location">
                                <img src="../../../../../assets/images/icons/loc-icon.png" alt="search icon"
                                    style="width: 18px" />

                                <span *ngIf="talentData?.location">{{ talentData?.location }}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="job-description">
                    <div *ngIf="talentData.about_yourself">
                        <p class="description-heading">About me</p>
                        <p class="description-text">{{ talentData?.about_yourself }}</p>
                    </div>
                    <div class="employment-types">
                        <span class="badge" *ngFor="let type of talentData?.work_type">{{ type }}</span>
                    </div>
                </div>
            </div>
            <!-- talents -->
        </div>
    </div>
</div>